<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M83.9396 83.2369C83.9396 83.7742 83.5105 84.2071 82.9805 84.2071C82.4506 84.2071 82.0215 83.7742 82.0215 83.2369C82.0215 82.6995 82.4506 82.2666 82.9805 82.2666C83.5105 82.2666 83.9396 82.6995 83.9396 83.2369Z"
            class="primary-fill" />
        <path
            d="M71.5059 49.0425H81.3204C82.8841 49.0425 84.1529 50.2628 84.1529 51.7704V78.7138C84.1529 81.3821 81.9884 83.5428 79.3202 83.5428H74.0472"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.1895 85.14C76.7192 85.14 77.1486 84.7056 77.1486 84.1697C77.1486 83.6339 76.7192 83.1995 76.1895 83.1995C75.6599 83.1995 75.2305 83.6339 75.2305 84.1697C75.2305 84.7056 75.6599 85.14 76.1895 85.14Z"
            class="primary-fill" />
        <path
            d="M65.9981 85.14C66.5278 85.14 66.9572 84.7056 66.9572 84.1697C66.9572 83.6339 66.5278 83.1995 65.9981 83.1995C65.4685 83.1995 65.0391 83.6339 65.0391 84.1697C65.0391 84.7056 65.4685 85.14 65.9981 85.14Z"
            class="primary-fill" />
        <path
            d="M72.9797 43.8889H73.3268C73.6589 43.8889 73.9276 43.6202 73.9276 43.2881C73.9276 42.956 74.1963 42.6873 74.5284 42.6873H77.1966C77.5287 42.6873 77.7974 42.956 77.7974 43.2881C77.7974 43.6202 78.0661 43.8889 78.3982 43.8889H78.7416C79.0588 43.8889 79.32 43.6464 79.3424 43.3292C79.3872 42.7022 79.4282 41.7693 78.596 41.7693H73.0655C72.4162 41.7693 72.3901 42.65 72.3751 43.2769C72.3677 43.6128 72.6401 43.8889 72.976 43.8889H72.9797Z"
            class="primary-fill" />
        <path
            d="M62.7225 79.9304V80.7589C62.7225 82.2964 63.9689 83.539 65.5027 83.539H75.4217C76.9592 83.539 78.2019 82.2926 78.2019 80.7589V52.7369C78.2019 50.6471 80.1573 49.0425 80.1573 49.0425H67.2752C64.76 49.0425 62.7188 51.0838 62.7188 53.599V62.962"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.128 62.4431H68.8145C64.8697 62.4431 61.6719 65.641 61.6719 69.5857V73.1682C61.6719 77.113 64.8697 80.3109 68.8145 80.3109H69.128C73.0727 80.3109 76.2706 77.113 76.2706 73.1682V69.5857C76.2706 65.641 73.0727 62.4431 69.128 62.4431Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M72.1159 51.2668H68.2274C65.9995 51.2668 64.1934 53.073 64.1934 55.3009V55.4763C64.1934 57.7042 65.9995 59.5103 68.2274 59.5103H72.1159C74.3439 59.5103 76.15 57.7042 76.15 55.4763V55.3009C76.15 53.073 74.3439 51.2668 72.1159 51.2668Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.127 43.6987V48.9046"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.5742 43.6987V48.9046"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.0664 61.6936L23.6342 37.9595C24.9515 32.3507 29.9521 28.3838 35.714 28.3838H101.606"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M99.457 37.8848H113.309"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M104.756 41.7881H118.384"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M99.5352 45.6917H108.663"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M102.543 58.6743L103.726 58.7415C105.226 58.8236 106.417 60.0327 106.484 61.5329L106.689 66.2162"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M102.682 61.6265V79.0613"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M99.4785 61.7231V79.3185"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.0312 61.8203V79.5724"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.6384 84.5507C89.3803 84.5507 89.9818 83.9492 89.9818 83.2072C89.9818 82.4653 89.3803 81.8638 88.6384 81.8638C87.8964 81.8638 87.2949 82.4653 87.2949 83.2072C87.2949 83.9492 87.8964 84.5507 88.6384 84.5507Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.8047 51.573V55.1555"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.0249 50.4983H93.0954C92.7223 50.4983 92.4199 50.8007 92.4199 51.1737V51.2558C92.4199 51.6289 92.7223 51.9313 93.0954 51.9313H97.0249C97.398 51.9313 97.7004 51.6289 97.7004 51.2558V51.1737C97.7004 50.8007 97.398 50.4983 97.0249 50.4983Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.3428 58.9915C90.0889 60.1296 89.3798 61.7492 89.3948 63.4435L89.5515 82.2666"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M102.684 58.6779C102.684 58.6779 98.4559 58.6182 95.2428 58.6182C92.0297 58.6182 92.2051 61.5887 92.2051 61.5887C92.2051 61.5887 91.929 82.8374 92.1007 82.6657L90.5744 82.5351C88.7794 82.3821 87.4023 80.882 87.4023 79.0832V62.9284C87.4023 60.7527 89.1675 58.9876 91.3431 58.9876"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M106.76 68.3213C106.973 79.6995 108.391 82.8528 97.2214 83.0581H95.9414"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M105.756 84.5953C106.498 84.5953 107.099 83.9938 107.099 83.2519C107.099 82.5099 106.498 81.9084 105.756 81.9084C105.014 81.9084 104.412 82.5099 104.412 83.2519C104.412 83.9938 105.014 84.5953 105.756 84.5953Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M94.0388 85.159C94.7807 85.159 95.3822 84.5576 95.3822 83.8156C95.3822 83.0736 94.7807 82.4722 94.0388 82.4722C93.2968 82.4722 92.6953 83.0736 92.6953 83.8156C92.6953 84.5576 93.2968 85.159 94.0388 85.159Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M93.3574 51.7295V56.7786"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M44.8649 83.1992C49.0296 83.1992 52.4218 86.5876 52.4218 90.756C52.4218 94.9244 49.0333 98.3129 44.8649 98.3129C40.6965 98.3129 37.3081 94.9244 37.3081 90.756C37.3081 86.5876 40.6965 83.1992 44.8649 83.1992ZM44.8649 81.8931C39.9726 81.8931 36.002 85.8599 36.002 90.756C36.002 95.6521 39.9688 99.619 44.8649 99.619C49.761 99.619 53.7279 95.6521 53.7279 90.756C53.7279 85.8599 49.761 81.8931 44.8649 81.8931Z"
            class="primary-fill" />
        <path
            d="M44.8646 87.4123C46.7081 87.4123 48.2083 88.9125 48.2083 90.756C48.2083 91.4762 47.9807 92.1629 47.5515 92.7413C46.9134 93.6033 45.9357 94.0959 44.8646 94.0959C43.0211 94.0959 41.521 92.5958 41.521 90.7523C41.521 89.364 42.3942 88.1064 43.6891 87.6213C44.066 87.4795 44.4616 87.4086 44.8646 87.4086M44.8646 86.1062C44.2899 86.1062 43.7376 86.2107 43.2301 86.401C41.4687 87.0615 40.2148 88.7632 40.2148 90.756C40.2148 93.3235 42.2972 95.4058 44.8646 95.4058C46.3984 95.4058 47.7568 94.6632 48.6039 93.5212C49.1748 92.7488 49.5144 91.7934 49.5144 90.756C49.5144 88.1885 47.4321 86.1062 44.8646 86.1062Z"
            class="primary-fill" />
        <path
            d="M82.7229 93.779H55.4959C55.4959 93.7454 55.507 93.7118 55.5182 93.6782C55.7795 92.7005 55.9175 91.6668 55.9026 90.5995C55.8466 86.4199 53.4396 82.7963 49.9504 80.9678C48.3831 80.1393 46.5881 79.684 44.6924 79.7064C42.9086 79.74 41.2293 80.1841 39.7403 80.9678C36.2212 82.8187 33.8217 86.5095 33.8217 90.76C33.8217 91.7713 33.9448 92.749 34.2061 93.6782C34.2172 93.7118 34.2172 93.7454 34.2284 93.779H22.0703C19.8089 93.779 17.9467 92.0288 17.79 89.771C17.4392 83.3822 17.2377 79.684 17.2787 72.9482C17.3347 68.4514 17.5511 63.8053 18.1072 59.6257"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17.2429 78.587H18.0377C18.9744 78.587 19.7394 79.3483 19.7394 80.2887V85.2818C19.7394 86.2185 18.9782 86.9798 18.0415 86.9798H17.2466C16.3099 86.9798 15.5449 86.2185 15.5449 85.2781V80.2849C15.5449 79.3483 16.3062 78.5833 17.2466 78.5833L17.2429 78.587Z"
            class="primary-fill" />
        <path
            d="M14.7007 38.7613L13.2565 38.6195L12.8161 38.5785C12.2302 38.5225 11.6966 38.9218 11.5846 39.5002L9.65159 49.4753C9.52471 50.1358 9.99491 50.7665 10.6629 50.8299L13.4468 51.0949C14.0737 51.1546 14.6335 50.6956 14.6932 50.0649L15.656 39.9965C15.712 39.392 15.2903 38.8546 14.697 38.7613H14.7007Z"
            class="primary-fill" />
        <path
            d="M46.7748 40.3698C46.8345 39.3958 46.062 38.571 45.0843 38.571H37.3483C32.3701 38.571 28.9406 42.5155 28.3323 47.587L26.5373 69.6157C26.4776 70.3695 27.071 71.0151 27.8285 71.0151H43.6849C44.3529 71.0151 44.9052 70.4964 44.9462 69.8284L46.771 40.3698H46.7748Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.935 61.07L42.5432 66.8021C42.5432 67.5409 41.9461 68.138 41.2072 68.138H30.7657C28.9297 68.138 29.4782 65.4176 29.6238 63.7009L30.7769 50.2404C30.7769 49.9792 30.7918 49.7254 30.818 49.4717C32.6391 53.7147 36.285 59.5251 42.935 61.0738V61.07Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.3301 74.5308H54.2746"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M13.457 40.4078L14.0317 37.1574C14.4124 34.9967 16.2895 33.4219 18.4837 33.4219H23.9359"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
